import React, { Component } from 'react'
import styled from 'styled-components'
// import { Button } from 'antd'
import './index.scss'

const ExpandBtn = styled.div`
  padding: 2px 6px;
  background: #286cac;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 18px;
  color: white;
  cursor: pointer;
`
const CollapseBtn = styled(ExpandBtn)`
  background: #dddddd;
`

export default class BaseCollapse extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expand: false
    }
  }
  render() {
    const { expand } = this.state
    const { title, children } = this.props
    return (
      <div className='collapse-card'>
        <div className="card-title">
          <div className="title-indicator"></div>
          <div className="title">{title}</div>
          <div className='line'></div>
          {expand ?
            (
              <CollapseBtn
                onClick={() => this.setState({ expand: !expand })}
              >
                收起
              </CollapseBtn>
            ) :
            (
              <ExpandBtn
                onClick={() => this.setState({ expand: !expand })}
              >
                展开
              </ExpandBtn>
            )}
        </div>
        <div className='card-body'>
          {expand ? children : null}
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/components/normal/BaseCollapse/index.js